export default __webpack_public_path__ + "static/media/low.ca904cc0.svg";